var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M558.1 532.6m-148.9 0a148.9 148.9 0 1 0 297.8 0 148.9 148.9 0 1 0-297.8 0Z",
    fill: "#FFB89A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M961 512.2c-2.6-98.1-222.3-347.9-446.9-347.9-224.6 0-449.1 257-449.1 347.9s202.9 347 449.1 347 449.5-248.9 446.9-347zM881.3 567c-16.5 29.4-40.3 60.5-68.9 89.9-40.1 41.2-86.7 75.9-134.8 100.4-54.7 27.9-109.7 42-163.5 42-48.5 0-98.4-12-148.3-35.7-44.1-20.9-88.3-51.3-127.8-87.8-34.4-31.8-65.1-68.3-86.5-102.7-21.7-34.9-26.5-55.7-26.5-60.9 0.2-5.1 5.9-26 29.9-61.5 23.2-34.3 55.9-71 92.2-103.4 40.9-36.5 85.7-66.9 129.3-88 48.3-23.3 94.7-35.1 137.8-35.1 43.6 0 90.2 11.7 138.3 34.7 43.6 20.8 87.9 51 128.3 87.1 35.9 32.2 68.2 68.9 90.8 103.3 22.9 34.8 29.3 57.3 29.5 64.4 0.1 6.4-3.9 24.7-19.8 53.3z",
    fill: "#45484C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M665.9 577.8c-13.7-9.3-32.4-5.7-41.7 8.1-24.7 36.6-65.8 58.4-109.9 58.4-73.1 0-132.5-59.4-132.5-132.5s59.4-132.5 132.5-132.5c24.6 0 48.6 6.8 69.4 19.6 14.1 8.7 32.6 4.3 41.3-9.8s4.3-32.6-9.8-41.3c-30.3-18.7-65.2-28.6-100.9-28.6-106.1 0-192.5 86.3-192.5 192.5 0 106.1 86.3 192.5 192.5 192.5 64 0 123.7-31.7 159.6-84.8 9.3-13.7 5.7-32.3-8-41.6z",
    fill: "#33CC99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M703.8 477.5c-4.9-27.3-15.5-52.7-31.3-75.5-9.5-13.6-28.2-17-41.8-7.5-13.6 9.5-16.9 28.2-7.5 41.8 10.9 15.7 18.2 33.1 21.5 51.9 2.6 14.5 15.2 24.7 29.5 24.7 1.8 0 3.6-0.2 5.4-0.5 16.3-3 27.1-18.6 24.2-34.9z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.73efb5076e910211a1e090e9a91fbd1f.svg";
export { ForwardRef as ReactComponent };